import { AutoCompleteSearch, PaginationList } from "Explore/Components";
import { getSuggestSearchAuthors } from "Explore/Services/Author";
import { getInstitutionScholarsByID } from "Explore/Services/Institution";
import { theme } from "antd";
import StickyBox from "react-sticky-box";
import InstitutionAwards from "../InstitutionAwards/InstitutionAwards";
import InstitutionPublications from "../InstitutionPublications/InstitutionPublications";
import InstitutionScholars from "../InstitutionScholars/InstitutionScholars";
import styles from "./ScholarsAndPeers.module.scss";
import { Tab, Tabs } from "@mui/material";
import useAuth from "Hooks/useAuth";

const ScholarsAndPeers = ({
  scholars,
  // publications,
  publicationVerify,
  setPublicationVerify,
  awards,
  tab,
  setTab,
  institution_id,
  landscape,
  setScholars,
  facultySearchFilter,
  setFacultySearchFilter,
  grantsFilter,
  setGrantsFilter,
  selectedKeywords,
  setSelectedKeywords,
  selectedKeywordsQueue,
  selectedDepartment,
  sliderValue,
  pagination,
  setPagination,
  showLoginSection,
}) => {
  const { userTypeConfig } = useAuth({
    entityType: "INSTITUTION",
  });
  const tabs = [
    {
      label: "Scholars",
      key: "scholars",
      children: InstitutionScholars,
      // data: scholars,
    },
    {
      label: "Notable Scholarly Works",
      key: "publications",
      children: InstitutionPublications,
      // data: publications,
    },
    {
      label: "Notable Federal Grants",
      key: "grants",
      children: InstitutionAwards,
      // data: awards.data,
      // isLoading: awards.isLoading,
    },
  ];
  const currentTab = tabs.find((item) => item.key === tab);
  const onChange = (_, key) => {
    setTab(key);
    setSelectedKeywords([]);
    setPagination({
      ...pagination,
      page: 1,
      rowsPerPage: 10,
    });
  };
  const handleClearSearch = () => {
    setFacultySearchFilter({ ...facultySearchFilter, query: null });
    setScholars({ data: [], isLoading: true });
    const keywordsForFiltering =
      selectedKeywordsQueue && !selectedKeywords.length > 0
        ? [...selectedKeywords, ...selectedKeywordsQueue.flat(Infinity)]
        : selectedKeywords;

    getInstitutionScholarsByID({
      id: institution_id,
      query: null,
      page: pagination.page - 1,
      rowsPerPage: pagination.rowsPerPage,
      startYear: sliderValue[0],
      endYear: sliderValue[1],
      keywords: keywordsForFiltering,
      department: selectedDepartment.departments,
      order_by: facultySearchFilter.orderBy,
    }).then((res) => {
      setScholars({ data: res.authors, isLoading: false });
      setPagination({ ...pagination, totalRows: res.total });
    });
  };

  return (
    <div className={styles["scholars-and-peers"]}>
      <div className={styles["tabs-landscape"]}>
        <div className={styles["top-result"]}>
          <Tabs
            className={styles["top-result--tabs"]}
            value={tab}
            onChange={onChange}
          >
            {tabs.map((tab) => (
              <Tab
                key={tab.key}
                value={tab.key}
                label={tab.label}
                style={{ textTransform: "none" }}
              />
            ))}
          </Tabs>

          <currentTab.children
            institution_id={institution_id}
            data={currentTab.data}
            isLoading={currentTab.isLoading}
            facultySearchFilter={facultySearchFilter}
            setFacultySearchFilter={setFacultySearchFilter}
            grantsFilter={grantsFilter}
            setGrantsFilter={setGrantsFilter}
            selectedKeywords={selectedKeywords}
            handleClearSearch={handleClearSearch}
            showLoginSection={showLoginSection}
            sliderValue={sliderValue}
          />

          {/* <PaginationList
            pagination={pagination}
            setPagination={setPagination}
            pageSizeOptions={[10, 20, 30, 50, 100]}
            sizeChanger={userTypeConfig?.ui_components?.pageSizeChanger}
          /> */}
        </div>
      </div>

      {/* <div className={styles["tabs-mobile"]}>
        <Tabs
          onChange={onChange}
          defaultActiveKey="1"
          renderTabBar={renderTabBar}
          items={tabs.map((item) => {
            return {
              label: item.label,
              key: item.key,
              children: (
                <item.children data={item.data} isLoading={item.isLoading} />
              ),
            };
          })}
        />
        <PaginationList pagination={pagination} setPagination={setPagination} />
      </div> */}
    </div>
  );
};

export default ScholarsAndPeers;
